export default __webpack_public_path__ + "static/media/ACSummaryIcon.1bf64638.svg";